export default __webpack_public_path__ + "static/media/mc-phone.bc269706.png";